import { Flex, notification, Pagination, Skeleton, Space } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useQueryClient } from "react-query";
import { useQuery, useMutation } from "@apollo/client/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Content } from "../../pages";
import { findModel } from "../../templates/main-template/MainTamplate.utils";
import { AddOrderModal } from "../add-order-modal/AddOrderModal";
import { setPageParam } from "../filters/Filter.utils";
import { Filters } from "../filters/Filters";
import { GlobalActions } from "../../molecules";
import { GET_FILTERS, CREATE_ITEM, GET_ITEMS } from "../../../graphql/items";
import {
  getPayrollCreateMutation,
  getPayrollListQuery,
} from "../../../graphql/payroll";

export const OrdersWraper: React.FC<{
  children: any;
  limit: any;
  setLimit: any;
  setOffSet: any;
  total: any;
  isFetching: any;
  global_actions: any;
}> = ({ children, limit, setLimit, setOffSet, total, global_actions }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { name } = useParams();
  const queryClient = useQueryClient();
  const models: any = queryClient.getQueryData(["/models"]);

  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);

  const { model } = useMemo(() => findModel(models, name), [models, name]);

  const dataType = model?.data_type;
  const createMutation = getPayrollCreateMutation(dataType) ?? CREATE_ITEM;
  const refetchListQuery = getPayrollListQuery(dataType) ?? GET_ITEMS;

  const { data: filtersData, loading: isFetchingFilters } = useQuery(GET_FILTERS, {
    variables: { itemModelId: Number(model?.id) },
    skip: !model,
  });

  const [createItem, { loading: isLoading }] = useMutation(createMutation, {
    refetchQueries: [{ query: refetchListQuery, variables: { itemModelId: Number(model?.id) } }],
    onCompleted: () => {
      notification.success({
        message: "Zapisano zmiany",
        style: {
          background: "#52c41a30",
        },
      });
    },
    onError: () => {
      notification.error({
        message: "Błąd zapisu danych",
        style: {
          background: "#ff4d4f30",
        },
      });
    },
  });

  const mutateAsync = async (args: { id: any; body: any }) => {
    await createItem({
      variables: { input: { itemModelId: Number(args.id), data: args.body } },
    });
  };

  const resetPagination = () => {
    setOffSet(0);
    setPage(1);
    const params = new URLSearchParams(location.search);
    params.delete("page");
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("page")) {
      setPage(parseInt(params.get("page") as string));
      setOffSet((parseInt(params.get("page") as string) - 1) * limit);
    }
  }, []);

  return (
    <Content>
      {filtersData && !isFetchingFilters && (
        <Filters
          filtersContols={(filtersData as any)?.filters}
          resetPagination={resetPagination}
        />
      )}
      {isFetchingFilters && <Skeleton active />}

      <Flex justify="space-between">
        {total > 0 && (
          <>
            <Space size={"small"}>
              <Pagination
                current={page}
                total={total}
                pageSize={limit}
                showSizeChanger={true}
                onShowSizeChange={(_, size) => setLimit(size)}
                onChange={(page) => {
                  setOffSet((page - 1) * limit);
                  setPage(page);
                  navigate({
                    pathname: location.pathname,
                    search: setPageParam(location.search, page),
                  });
                }}
              />
            </Space>
            <Space size={"small"}>
              <GlobalActions total={total} global_actions={global_actions} />
            </Space>
          </>
        )}
      </Flex>
      {children}
      {total > 0 && (
        <Pagination
          total={total}
          current={page}
          pageSize={limit}
          showSizeChanger={true}
          onShowSizeChange={(_, size) => setLimit(size)}
          onChange={(page) => {
            setOffSet((page - 1) * limit);
            setPage(page);
            navigate({
              pathname: location.pathname,
              search: setPageParam(location.search, page),
            });
          }}
        />
      )}
      <AddOrderModal
        open={open}
        setOpen={setOpen}
        mutateAsync={mutateAsync}
        isLoading={isLoading}
        hardcodedControls={[]}
      />
    </Content>
  );
};
